import styles from './tax-id-number-section.module.sass';
import classNames from 'classnames/bind';
import { InfoCircleFillIcon } from 'icons';

const cx = classNames.bind(styles);

export const TaxIdNumberSection = ({ enterpriseTaxSettings }) => {
  const list = enterpriseTaxSettings.map(({ taxIdNumber, title }) => ({
    taxId: taxIdNumber,
    name: title,
  }));

  return (
    <section className={cx('section-container')} style={{ marginBottom: '16px' }}>
      <div className={cx('section-title')}>發票歸帳</div>
      <ul className={cx('section-tax-id-number-list')}>
        {list.map(({ taxId, name }) => (
          <li key={taxId} className={cx('section-tax-id-number-list-item')}>{`${taxId} (${name})`}</li>
        ))}
      </ul>
      <div className={cx('section-tax-id-number-hint')}>
        <InfoCircleFillIcon width={20} height={20} style={{ marginRight: '4px' }} />
        您可以前往付款車牌頁，設定車牌與發票歸帳的關聯；若需修改發票歸帳設定，請聯繫業務人員。
      </div>
    </section>
  );
};
